import React, { useState, useEffect } from 'react';
import './toast.css';

export let showErrorToast = () => {};

const Toast = ({ toast, onClose }) => {
    const {message, duration, id, iconPath, typeClass} = toast;
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        setVisible(true);

        const timer = setTimeout(() => {
            setVisible(false);
            onClose(toast.id);
        }, duration);

        // return () => clearTimeout(timer);
    }, [duration, id, onClose]);

    const handleCloseClick = () => {
        setVisible(false);
        onClose(id);
    };

    return (
        <div className={`toast ${visible ? 'show' : ''} ${typeClass}`} onClick={handleCloseClick}>
            {iconPath ? <img src={iconPath} className={"toast-icon"}/> : null}
                <div className="toast-message">{message}</div>
        </div>
    );
};




export const ToastsContainer = () => {
    const [toasts, setToasts] = useState([]);

    showErrorToast = (message, duration=3000) => {
        const newToast = {
            id: Date.now(),
            message:message,
            iconPath: "./assets/singleIcons/errorIcon.svg",
            duration,
            typeClass: "toast-error",
        };

        setToasts((prevToasts) => [...prevToasts, newToast]);
    };

    const handleCloseToast = (id) => {
        setToasts((prevToasts) => prevToasts.filter((toast) => {
            return toast.id !== id
        }));
    };

    return (<>
        <div className={'toasts-container'}>
            {toasts.map((toast) => (
                <Toast
                    key={toast.id}
                    onClose={handleCloseToast}
                    toast={toast}
                />
            ))}
        </div>
    {/*<button id="addNotification" style={{position:"absolute"}} onClick={() => showErrorToast('Task completed successfully!')}>*/}
    {/*    Show Toast*/}
    {/*</button>*/}
        </>
    );
}
